import { type CreateJingleCollectionModel } from '@/shared/api'
import { formatDayjsToDateString } from '@/shared/lib/form-utils'

import { type JingleCollectionFormCommonInformationModel } from '../ui/JingleCollectionFormCommonInformation'

export function getJingleCollectionRequestByFormValues(
  values: JingleCollectionFormCommonInformationModel,
): CreateJingleCollectionModel {
  return {
    name: values.name,
    frequency: values.frequency,
    startDate: formatDayjsToDateString(values.startDate),
    endDate:
      values.endDate && values.dateRangeSelection
        ? formatDayjsToDateString(values.endDate)
        : null,
  }
}
